import React, { useContext, useState, useEffect, useMemo, useRef } from 'react'
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, Box, TableSortLabel, TextField } from "@mui/material";
import { ThemeContext } from '../../../../context/ThemeContext';
import { deleteAlert, updateAlert } from '../../../../api/request/dashboard/dashboard';
import toast from "react-hot-toast";
import EditAlertDialog from './EditAlertDialog';
import DeleteAlert from './DeleteAlert';
import AlertCellConfig from '../../../tablecells/Alerts';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TableVirtuoso } from "react-virtuoso";
import { updateAlertData, deleteAlertData } from '../../../../store/Slices/alertSlice';
import NoDataTable from '../../../table/NoDataTable';
import { calculateAccountMetrics } from '../../../footer/AccountCalculation'
import NewAlert from './NewAlert';
import moment from 'moment';

export default function Alert({ data = [] }) {
  const { darkMode } = useContext(ThemeContext);
  const [open, setOpen] = useState(false);
  const [additionalSymbol, setAdditionalSymbol] = useState("")
  const [bid, setBid] = useState(null);
  const [ask, setAsk] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const accountId = localStorage.getItem("accountID");
  const handleOpen = () => setOpen(true);
  const [alertToDelete, setAlertToDelete] = useState(null);
  const { t } = useTranslation()
  // const [digit, setDigit] = useState(null)
  const { accountSummary = [] } = useSelector(state => state.accountSummary)
  const { alert = [] } = useSelector(state => state.alert)
  // const symbols = useSymbolPrices()
  const { symbols } = useSelector(state => state.watchlist)
  const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');
  const { UserCompleteDetails } = useSelector(state => state.user);
  const imgSrc = darkMode ? '/hs-white.png' : '/hs-logo.png'

  const getSymbolDigits = (symbolId) => {
    const symbol = symbols?.[symbolId];
    return symbol?.digits ?? decimalPlaces;
  };


  const dispatch = useDispatch();

  const handleEdit = (alert) => {
    setEditOpen(true);
    setSelectedAlert(alert)
  };

  const handleDeleteOpen = (alert) => {
    console.log('open', alert);

    setAlertToDelete(alert);
    setDeleteOpen(true);
  };
  const handleDelete = async () => {
    if (!alertToDelete) {
      console.error("No alert selected for deletion.");
      return;
    }

    let data = { id: alertToDelete.id, accountId };

    try {
      await deleteAlert(data);
      dispatch(deleteAlertData(alertToDelete.id))
      // toast.success("Alert deleted successfully!");
      setDeleteOpen(false);;
    } catch (error) {
      console.error("Error deleting alert:", error);
      toast.error("Failed to delete alert.");
    }
  };

  const hasCheckedOnce = useRef(false);

  // useEffect(() => {
  //   if (accountSummary && !hasCheckedOnce.current) {
  //     checkAlertsCondition(accountSummary, bid, ask);
  //     hasCheckedOnce.current = true;
  //   }
  // }, [accountSummary]);
  useEffect(() => {
    if (accountSummary && bid !== null && ask !== null && !hasCheckedOnce.current) {
      checkAlertsCondition(accountSummary, bid, ask);
      hasCheckedOnce.current = true;
    }
  }, [accountSummary, bid, ask]);



  useEffect(() => {
    if (additionalSymbol) {
      const selectedSymbol = Object.values(symbols).find(
        (symbol) => symbol.symbolID === Number(additionalSymbol)
      );
      if (selectedSymbol) {
        setBid(selectedSymbol.bid);
        setAsk(selectedSymbol.ask);
        // setDigit(selectedSymbol.digits)
      }
    }
  }, [symbols, additionalSymbol]);


  const handleUpdate = async (updatedAlert) => {
    try {

      // Ensure proper data structure
      const sanitizedPayload = {
        id: updatedAlert.id,
        accountId: Number(updatedAlert.accountId),  // Ensure it's a number
        symbolId: updatedAlert.symbolId ? Number(updatedAlert.symbolId) : null,
        condition: updatedAlert.condition,
        type: updatedAlert.type,
        value: updatedAlert.value,
        enabled: updatedAlert.enabled,
        hitPrice: updatedAlert.hitPrice ? updatedAlert.hitPrice : null,  // Ensure it's a number
        // hitDateTime: updatedAlert.hitDateTime ?? null
      };
      const response = await updateAlert(sanitizedPayload);

      if (response.status === 200) {
        // toast.success("Alert updated successfully!");
        dispatch(updateAlertData(updatedAlert));
        // dispatch(updateAlertData(alert.map(alert => alert.id === updatedAlert.id ? updatedAlert : alert)));
        setEditOpen(false);
      }
    } catch (error) {
      console.error("Error updating alert:", error);
      toast.error("Failed to update alert.");
    }
  };
  const columns = AlertCellConfig({ handleOpen, handleEdit, handleDeleteOpen, symbols });
  const triggeredAlertIdsRef = useRef(new Set());
  const checkAlertsCondition = (accountSummary, ask, bid) => {
    if (!Array.isArray(alert)) return;
    console.log(triggeredAlertIdsRef);

    alert.forEach((alert) => {
      if (triggeredAlertIdsRef.current.has(alert.id)) return;

      const conditionLabel = conditionMap[alert.condition];
      const {
        floatingProfitLoss,
        calculatedEquity,
        calculatedMarginLevel,
      } = calculateAccountMetrics(accountSummary);

      let shouldTrigger = false;

      switch (alert.condition) {
        case 1: shouldTrigger = bid > alert.value; break;  // Ask > value
        case 2: shouldTrigger = bid < alert.value; break;  // Ask < value
        case 3: shouldTrigger = ask > alert.value; break;  // Bid > value
        case 4: shouldTrigger = ask < alert.value; break;  // Bid < value
        case 5: shouldTrigger = parseFloat(accountSummary?.balance || 0) > alert.value; break;
        case 6: shouldTrigger = parseFloat(accountSummary?.balance || 0) < alert.value; break;
        case 7: shouldTrigger = calculatedEquity > alert.value; break;
        case 8: shouldTrigger = calculatedEquity < alert.value; break;
        case 9: shouldTrigger = calculatedMarginLevel > alert.value; break;
        case 10: shouldTrigger = calculatedMarginLevel < alert.value; break;
        case 11: shouldTrigger = floatingProfitLoss > alert.value; break;
        case 12: shouldTrigger = floatingProfitLoss < alert.value; break;
        default: break;
      }

      if (shouldTrigger) {
        handleAlert(alert, conditionLabel);
        triggeredAlertIdsRef.current.add(alert.id); // mark as triggered
      }
    });
  };

  // const triggeredAlertIdsRef = useRef(new Set());


  const handleAlert = (alert, conditionLabel) => {
    // const triggeredAlertIds = triggeredAlertIdsRef.current;

    // Skip if already triggered
    if (triggeredAlertIdsRef.has(alert.id)) return;

    const hitTime = new Date().toISOString();
    const updatedAlert = {
      ...alert,
      hitDateTime: alert.hitDateTime || hitTime,
    };

    setTimeout(() => {
      if (updatedAlert.type === 1) {
        playSound();
        triggeredAlertIdsRef.add(alert.id); // Mark as triggered
      } else if (updatedAlert.type === 2) {
        toast((t) => (
          <div className="bg-white border border-gray-300 rounded-md shadow-md p-4 flex justify-between items-center max-w-md">
            <div>
              <strong>{conditionLabel}</strong> ({updatedAlert.value}) has been hit at<br />
              <span className="text-sm text-gray-500">{updatedAlert.hitDateTime}</span>
            </div>
            <button className="ml-4 text-red-500 font-semibold" onClick={() => { toast.dismiss(t.id); triggeredAlertIdsRef.add(alert.id); }}>✕</button>
          </div>
        ), {
          duration: 200,
        });
      }
    }, 500);
  };

  const typeMap = {
    1: "alert_type_sound",
    2: "alert_type_sms",
  };

  const conditionMap = {
    1: "condition_bid_gt",
    2: "condition_bid_lt",
    3: "condition_ask_gt",
    4: "condition_ask_lt",
    5: "condition_balance_gt",
    6: "condition_balance_lt",
    7: "condition_equity_gt",
    8: "condition_equity_lt",
    9: "condition_marginlevel_gt",
    10: "condition_marginlevel_lt",
    11: "condition_pl_gt",
    12: "condition_pl_lt",
  };

  const playSound = () => {
    // const audio = new Audio('/mixkit-elevator-tone-2863.wav');
    // audio.play();
    console.log('alert triggerd with type sound');
  };
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };
  const sortedAlerts = useMemo(() => {
    const searchLower = searchQuery?.toLowerCase?.() || "";
    let filteredData = [...alert];

    if (searchLower) {
      filteredData = filteredData.filter((item) => {
        const symbolName = symbols?.[item.symbolId]?.name?.toLowerCase?.() || "";

        // Check symbolName + all string fields of the alert
        const matchesSymbol = symbolName.includes(searchLower);
        const matchesAlertFields = Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchLower)
        );

        return matchesSymbol || matchesAlertFields;
      });
    }

    if (sortConfig.key) {
      filteredData.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];

        if (aVal == null || bVal == null) return 0;

        const isNumeric = typeof aVal === "number" && typeof bVal === "number";

        if (isNumeric) {
          return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
        }

        return sortConfig.direction === 'asc'
          ? String(aVal).localeCompare(String(bVal))
          : String(bVal).localeCompare(String(aVal));
      });
    }


    return filteredData;
  }, [alert, sortConfig, searchQuery]);

  const offsetToMinutes = (offset) => {
    const [hours, minutes, seconds] = offset.split(":").map(Number);
    return hours * 60 + minutes + Math.sign(hours) * (seconds > 0 ? 1 : 0);
  };
  const formatDateTime = (serverDateTime) => {
    if (!serverDateTime) return "--";

    const serverTime = moment.parseZone(serverDateTime);
    const serverOffsetMin = offsetToMinutes(UserCompleteDetails?.serverGMTOffset || "00:00:00");
    const clientOffsetMin = offsetToMinutes(UserCompleteDetails?.gmtOffset || "00:00:00");
    const diffOffset = clientOffsetMin - serverOffsetMin;

    return serverTime.add(diffOffset, "minutes").format("DD-MM-YYYY HH:mm:ss");
  };
  const Row = useMemo(() => (index, alert) => {
    return (
      <>
        {columns.map((col, colIndex) => (
          <TableCell key={colIndex} sx={{
            fontSize: "0.8rem", border: "none", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", position: "relative", overflow: "hidden", fontWeight: alert.hitPrice || alert.hitDateTime ? "bold" : "normal",
          }}>
            {col.field === "actions" ? (col.render(alert)
            ) : col.field === "condition" ? (
              (() => {
                const digits = getSymbolDigits(alert.symbolId);
                const fixedValue = !isNaN(alert.value) ? Number(alert.value).toFixed(digits) : "-";
                return `${t(conditionMap[Number(alert.condition)] || alert.condition)} : ${fixedValue}`;
              })()
            ) :
              col.field === "hitPrice" ? (alert.hitPrice != null ? Number(alert.hitPrice).toFixed(getSymbolDigits(alert.symbolId)) : "-"
              ) : col.field === "symbolId" ? (symbols?.[alert.symbolId]?.name || "-"
              ) : col.field === "hitDateTime" ? (alert.hitDateTime != null ? formatDateTime(alert.hitDateTime) : "-"
              ) : (alert[col.field] || "-"
              )}
          </TableCell>
        ))}
      </>
    );
  }, [columns, darkMode, t]);

  const fixedHeaderContent = () => {
    return (
      <TableRow sx={{ borderTop: `1px solid ${darkMode ? "var(--borderDark)" : "var(--borderLight)"}` }}>
        {columns.map((col, index) => (
          <TableCell onClick={() => col.field !== 'actions' && handleSort(col.field)} key={index} sx={{ fontSize: "0.85rem", fontWeight: 550, textTransform: "capitalize", p: 1, backgroundColor: darkMode ? "var(--background-color)" : "var(--white)", borderBottom: "1px solid rgba(224, 224, 224, 0.3)", borderRight: `1px solid ${darkMode ? "#444" : "var(--borderLight)"}`, cursor: col.field !== t('actions') ? "pointer" : "default", }}>
            <TableSortLabel active={sortConfig.key === col.field} direction={sortConfig.direction}>
              {col.title}
            </TableSortLabel>

          </TableCell>
        ))}
      </TableRow>);
  }

  const VirtuosoTableComponents = {
    Table: (props) => <Table {...props} sx={{ borderCollapse: "separate", tableLayout: "fixed" }} />,
    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
  };

  return (
    <>
      <Paper style={{ width: "100%", height: "calc(100% - 35px)", backgroundColor: darkMode ? "#151924" : "#fff", }}>
        {alert.length === 0 ? (
          <NoDataTable columns={columns} data={alert} noDataMessage={t('noData')} />
        ) : (
          <>
            <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", height: '100%' }}>
              <TableVirtuoso data={sortedAlerts.filter(Boolean)} fixedHeaderContent={fixedHeaderContent} itemContent={(index, alert) => Row(index, alert)} components={VirtuosoTableComponents} itemKey={(index, alert) => alert.id} />
            </Box>

          </>
        )}
      </Paper>
      <div style={{ height: 35 }}>
        <div className='flex items-center px-1 justify-between'>
          <TextField size="small" variant="outlined" placeholder={t("mobSearch")} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ width: '250px', mx: 1, mt: 0.3 }} InputProps={{ sx: { fontSize: 13, padding: 0, height: 30, "& input": { padding: "0", paddingLeft: 1, height: "30px", }, }, }} />
          <div className='flex items-center opacity-50'>
            <small>{t('poweredby')} </small><a href="https://hybridsolutions.com/" target='_blank'><img src={imgSrc} alt="hs" style={{ height: darkMode ? 40 : 20 }} className='ms-2' />
            </a>
          </div>
        </div>
      </div>
      {open && (<NewAlert open={open} onClose={() => setOpen(false)} />)}
      <EditAlertDialog open={editOpen} handleClose={() => setEditOpen(false)} alertData={selectedAlert} symbolData={symbols} handleUpdate={handleUpdate} />
      <DeleteAlert open={deleteOpen} handleClose={() => setDeleteOpen(false)} handleDelete={handleDelete} />
    </>
  )
}
